var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iconInput"},[_c('Dropdown',{attrs:{"popper-class":_vm.popperClass},scopedSlots:_vm._u([{key:"popper",fn:function(){return [_c('icon-picker',{attrs:{"series":_vm.series},on:{"input":_vm.iconChanged}})]},proxy:true}])},[_c('button',{staticClass:"iconSelector"},[_c('i',{staticClass:"iconfont2",class:_vm.value})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }